/*
  Il Rito: tre domande, poi il Daymon (5 ottobre 2026). Nessuna libreria,
  nessun testo qui dentro: tutto arriva dal JSON di #rito-data, il punteggio
  da rito-punteggio.js, l'apparizione da daymon-voce.js.

  Stati: intro, domanda, voce, doppio, esito, ritorno, fermo; la conferma e'
  un dialog. Ogni domanda e' una voce di cronologia, e anche l'esito: chi
  torna indietro dalla scheda ritrova la pagina nera con la sua dedica. Il
  nome di chi riceve sta solo nella sessione (rito_state, poi
  daymonilia-dedica per la scheda): mai nel deposito del browser, mai negli
  eventi. Senza questo file restano i cinque monili con il prezzo: e' lo
  script che scrive data-rito="pronto".
*/
(function () {
  'use strict';

  var radice = document.querySelector('[data-rito]');
  var fonte = document.getElementById('rito-data');
  var motore = window.RitoPunteggio;
  if (!radice || !fonte || !motore) return;

  var dati;
  try { dati = JSON.parse(fonte.textContent); } catch (e) { return; }
  if (!dati || dati.v !== 3 || !dati.domande || !dati.domande.length || !dati.nature) return;

  /* I testi arrivano dal filtro t gia' codificati per l'HTML (l'apostrofo e' &#39;) e qui finiscono in
     textContent: si decodificano una volta sola, tutte le stringhe del JSON (19 ottobre 2026). */
  var decodificatore = document.createElement('textarea');
  (function decodifica(o) {
    for (var k in o) {
      if (!Object.prototype.hasOwnProperty.call(o, k)) continue;
      if (typeof o[k] === 'string') { if (o[k].indexOf('&') > -1) { decodificatore.innerHTML = o[k]; o[k] = decodificatore.value; } }
      else if (o[k] && typeof o[k] === 'object') decodifica(o[k]);
    }
  })(dati);

  var N = dati.domande.length;
  var regole = dati.regole || {};
  var testi = dati.testi || {};
  var nature = dati.nature;
  var pigro = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var DURATA = pigro ? 0 : 400;
  var STATO = 'rito_state';
  var ESITO = 'rito_result';
  var DEDICA = 'daymonilia-dedica';
  var VECCHIA = 'daymonilia-rito';
  /* La chiave di sessione dell'apparizione, la stessa della pagina I Daymon (sections/daymon-voce.liquid). */
  var VOCE = 'daymonilia-daymon-voce';

  function el(sel, dove) { return (dove || radice).querySelector(sel); }
  function tutti(sel, dove) { return Array.prototype.slice.call((dove || radice).querySelectorAll(sel)); }

  var scena = el('[data-rito-scena]');
  var lista = el('[data-rito-passi]');
  var esito = el('[data-rito-esito]');
  var doppio = el('[data-rito-doppio]');
  var riepilogo = el('[data-rito-riepilogo]');
  var conferma = el('[data-rito-conferma]');
  var voce = el('[data-rito-voce]');
  var frazione = el('[data-rito-frazione]');
  var indietro = el('[data-rito-indietro]');
  var perChi = el('[data-rito-per-chi]');
  var campoDono = el('[data-rito-dono-campo]');
  var campoNome = el('[data-rito-per-nome]');
  var radiceVoce = el('[data-daymon-voce]');
  var schermi = tutti('[data-rito-schermo]');
  if (!scena || !lista || !esito || !doppio || !riepilogo) return;

  /* La memoria: sessione per il rito in corso, deposito per l'esito, RAM se il browser nega tutto. */
  var ram = {};
  function leggi(dove, chiave) {
    try { var g = window[dove].getItem(chiave); return g ? JSON.parse(g) : null; } catch (e) { return ram[chiave] || null; }
  }
  function scrivi(dove, chiave, valore) {
    ram[chiave] = valore;
    try { window[dove].setItem(chiave, JSON.stringify(valore)); } catch (e) {}
  }
  function cancella(dove, chiave) {
    delete ram[chiave];
    try { window[dove].removeItem(chiave); } catch (e) {}
  }

  /* Ogni evento porta la versione del Rito: dal 5 ottobre 2026 q va da 1 a 3 e vuol dire altre domande. */
  function misura(nome, d) {
    d = d || {};
    d.v = 3;
    try {
      if (window.Daymonilia && typeof window.Daymonilia.misura === 'function') { window.Daymonilia.misura(nome, d); return; }
      var e = { event: nome };
      for (var k in d) if (Object.prototype.hasOwnProperty.call(d, k)) e[k] = d[k];
      (window.dataLayer = window.dataLayer || []).push(e);
    } catch (err) {}
  }

  /* Il caso con seme (mulberry32): le opzioni si mescolano una volta per rito e restano cosi' tornando indietro. */
  var imul = Math.imul || function (a, b) {
    var ah = (a >>> 16) & 0xffff, al = a & 0xffff, bh = (b >>> 16) & 0xffff, bl = b & 0xffff;
    return (al * bl + (((ah * bl + al * bh) << 16) >>> 0)) | 0;
  };
  function mulberry32(a) {
    return function () {
      a = (a + 0x6D2B79F5) | 0;
      var t = imul(a ^ (a >>> 15), 1 | a);
      t = (t + imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  function mescola(voci, seme) {
    var caso = mulberry32(seme), copia = voci.slice(), i, j, t;
    for (i = copia.length - 1; i > 0; i--) { j = Math.floor(caso() * (i + 1)); t = copia[i]; copia[i] = copia[j]; copia[j] = t; }
    return copia;
  }

  function sost(t, m) { return String(t == null ? '' : t).replace(/@([a-z]+)/g, function (x, k) { return m[k] == null ? x : m[k]; }); }
  function romano(n) { return (dati.romani && dati.romani[n - 1]) || String(n); }
  function annuncia(t) { if (voce) voce.textContent = t; }

  var stato, raggiunto = 0, passi = [], corrente = null, ultimoDoppio = null, memEsito = null;
  var modo = 'proprio', inCorso = false, attesa = null, avviato = false, parla = null, daConferma = null;

  function nuovoStato() {
    var a = [];
    for (var i = 0; i < N; i++) a.push(null);
    return { v: 3, step: 0, answers: a, seed: (Date.now() ^ Math.floor(Math.random() * 1e9)) >>> 0, salti: 0, ts: Date.now(), dono: false, per: '' };
  }
  function risposte() { var r = []; for (var i = 0; i < N; i++) r.push(stato.answers[i] == null ? null : stato.answers[i]); return r; }
  /* I salti: le domande gia' passate senza risposta, piu' quella che si sta saltando adesso. */
  function contaSalti(q) {
    var n = 0;
    for (var i = 0; i < N; i++) if (stato.answers[i] == null && (i < raggiunto - 1 || i === q - 1)) n++;
    return n;
  }
  function salva() {
    stato.salti = contaSalti(0);
    stato.raggiunto = raggiunto;
    stato.ts = Date.now();
    scrivi('sessionStorage', STATO, stato);
  }

  /* La voce del Daymon e' provvisoria: chi la segue ne prende il posto nella cronologia. */
  function storia(passo) { try { var h = window.history; h[h.state && h.state.rito === 'voce' ? 'replaceState' : 'pushState']({ rito: passo }, ''); } catch (e) {} }
  function sostituisciStoria(passo, via) { try { window.history.replaceState({ rito: passo }, '', via || window.location.href); } catch (e) {} }

  /* In corso vale anche mentre il Daymon parla: popup.js non apre l'invito sopra di lui. */
  function schermo(nome) {
    for (var i = 0; i < schermi.length; i++) schermi[i].hidden = schermi[i].getAttribute('data-rito-schermo') !== nome;
    radice.setAttribute('data-rito-stato', nome);
    if (nome === 'domanda' || nome === 'voce') radice.setAttribute('data-rito-in-corso', '');
    else radice.removeAttribute('data-rito-in-corso');
  }
  /* Il fuoco va al primo bersaglio visibile: nell'esito la dedica, e il nome del monile quando la dedica non c'e'. */
  function fuoco(nome) {
    var s = el('[data-rito-schermo="' + nome + '"]');
    var t = s && s.querySelector('[data-rito-fuoco]:not([hidden])');
    if (t && avviato) t.focus();
    return t;
  }
  /* Il passaggio fra due schermate: dissolvenza di 400 ms in uscita, poi in entrata. Zero se il sistema chiede meno movimento. */
  function dissolvi(poi, forza) {
    if (inCorso && !forza) return;
    window.clearTimeout(attesa);
    if (!DURATA || !avviato) { inCorso = false; poi(); scena.classList.remove('rito__scena--via'); return; }
    inCorso = true;
    scena.classList.add('rito__scena--via');
    attesa = window.setTimeout(function () {
      inCorso = false;
      poi();
      void scena.offsetWidth;
      scena.classList.remove('rito__scena--via');
    }, DURATA);
  }

  /* Le domande: un fieldset per domanda, costruito dal JSON, uno visibile per volta. */
  function costruisci() {
    while (lista.firstChild) lista.removeChild(lista.firstChild);
    passi = [];
    for (var q = 1; q <= N; q++) {
      var d = dati.domande[q - 1];
      var fs = document.createElement('fieldset');
      fs.className = 'rito__passo';
      fs.setAttribute('data-passo', String(q));
      fs.setAttribute('role', 'radiogroup');
      fs.setAttribute('aria-labelledby', 'rito-domanda-' + q);
      fs.hidden = true;
      var h = document.createElement('h2');
      h.className = 'rito__domanda';
      h.id = 'rito-domanda-' + q;
      h.tabIndex = -1;
      h.textContent = d.testo;
      fs.appendChild(h);
      var box = document.createElement('div');
      box.className = 'rito__opzioni';
      var opzioni = mescola(d.opzioni || [], (stato.seed + q * 7919) >>> 0);
      for (var o = 0; o < opzioni.length; o++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'rito__opzione';
        b.setAttribute('role', 'radio');
        b.setAttribute('data-opzione', opzioni[o].natura);
        b.textContent = opzioni[o].testo;
        box.appendChild(b);
      }
      fs.appendChild(box);
      lista.appendChild(fs);
      passi.push(fs);
      segnaRadio(fs, stato.answers[q - 1]);
    }
  }
  function segnaRadio(fs, natura) {
    var opz = tutti('[data-opzione]', fs), scelto = -1, i;
    for (i = 0; i < opz.length; i++) if (natura && opz[i].getAttribute('data-opzione') === natura) scelto = i;
    for (i = 0; i < opz.length; i++) {
      opz[i].setAttribute('aria-checked', i === scelto ? 'true' : 'false');
      opz[i].tabIndex = i === scelto || (scelto < 0 && i === 0) ? 0 : -1;
    }
  }
  function mostraDomanda(q, daStoria) {
    stato.step = q;
    if (q > raggiunto) raggiunto = q;
    schermo('domanda');
    for (var i = 0; i < passi.length; i++) passi[i].hidden = i !== q - 1;
    if (frazione) {
      frazione.textContent = sost(testi.frazione, { n: romano(q), tot: romano(N) });
      frazione.setAttribute('aria-label', sost(testi.frazione, { n: q, tot: N }));
    }
    if (indietro) indietro.hidden = q === 1;
    salva();
    if (!daStoria) storia(q);
    var titolo = passi[q - 1].querySelector('.rito__domanda');
    if (titolo && avviato) titolo.focus();
    annuncia(sost(testi.annuncio_passo, { n: q, tot: N, domanda: dati.domande[q - 1].testo }));
  }
  function scegli(b) {
    var fs = b.closest('[data-passo]');
    if (!fs || inCorso) return;
    var q = Number(fs.getAttribute('data-passo'));
    if (q !== stato.step) return;
    var natura = b.getAttribute('data-opzione');
    stato.answers[q - 1] = natura;
    segnaRadio(fs, natura);
    misura('rito_answer', { q: q, natura: natura, skipped: false });
    avanza(q);
  }
  function avanza(q) {
    if (q < N) dissolvi(function () { mostraDomanda(q + 1); });
    else compi();
  }
  function saltaDomanda() {
    if (inCorso || stato.step < 1 || stato.step > N) return;
    var q = stato.step;
    stato.answers[q - 1] = null;
    segnaRadio(passi[q - 1], null);
    misura('rito_skip', { q: q });
    if (contaSalti(q) > (regole.salti_max == null ? 3 : regole.salti_max)) { fermo(); return; }
    misura('rito_answer', { q: q, natura: null, skipped: true });
    avanza(q);
  }
  function vaiIndietro() {
    if (inCorso || stato.step <= 1) return;
    var s = null;
    try { s = window.history.state; } catch (e) {}
    if (s && s.rito === stato.step) { window.history.back(); return; }
    misura('rito_back', { q: stato.step });
    dissolvi(function () { mostraDomanda(stato.step - 1, true); });
  }
  function fermo() {
    cancella('sessionStorage', STATO);
    dissolvi(function () { schermo('fermo'); var t = fuoco('fermo'); if (t) annuncia(t.textContent); });
  }

  /* Il compimento: il punteggio e la memoria subito, poi il Daymon parla, poi il monile. */
  function compi() {
    misura('rito_complete', { salti: contaSalti(N) });
    var v = motore.vincitore(risposte(), regole.pesi || [], { soglia_forte: regole.soglia_forte, ancore: regole.ancore, nature: dati.ordine });
    var poi;
    cancella('sessionStorage', STATO);
    if (v.doppia) {
      ultimoDoppio = v;
      misura('rito_reveal', { natura: null, dual: true, tie_break: v.tie_break, forte: v.forte });
      poi = function () { mostraDoppio(v); };
    } else {
      ricorda(v.natura, null, v.tie_break);
      misura('rito_reveal', { natura: v.natura, dual: false, tie_break: v.tie_break, forte: v.forte });
      poi = function () { mostraEsito(v.natura); };
    }
    dissolvi(function () { appari(poi); });
  }
  /*
    Il Daymon. Se la pagina I Daymon lo ha gia' fatto parlare in questa
    sessione, qui dice solo l'ultima riga; se no parla tutto, e la chiave
    scritta qui tiene ferma la pagina I Daymon. Se lo script manca o la
    sequenza non parte (meno movimento), il monile arriva subito.
  */
  function appari(poi) {
    var dv = window.DaymonVoce;
    parla = null;
    if (dv && radiceVoce) {
      var breve = dv.vista(VOCE);
      if (breve) soloUltima();
      schermo('voce');
      if (testi.annuncio_voce) annuncia(testi.annuncio_voce);
      parla = dv.avvia(radiceVoce, { chiave: '', fuoco: true, allaFine: function () { parla = null; dissolvi(poi, true); } });
      if (parla && !breve) { try { window.sessionStorage.setItem(VOCE, '1'); } catch (e) {} }
    }
    if (parla) storia('voce');
    else poi();
  }
  /* Le righe prima dell'ultima escono dalla sequenza e dalla vista. Se il componente le ha gia' contate (un Rito rifatto), si corregge anche il suo elenco. */
  function soloUltima() {
    var righe = tutti('[data-daymon-voce-riga]', radiceVoce), ultima = righe[righe.length - 1];
    if (righe.length < 2) return;
    for (var i = 0; i < righe.length - 1; i++) { righe[i].removeAttribute('data-daymon-voce-riga'); righe[i].hidden = true; }
    if (radiceVoce.__daymonVoce) radiceVoce.__daymonVoce.righe = [ultima];
  }
  function ricorda(natura, doppia, come) {
    memEsito = { v: 2, natura: natura, ts: Date.now(), dual: doppia, tie_break: come };
    scrivi('localStorage', ESITO, memEsito);
  }

  function campo(nome, valore, dove) {
    var n = tutti('[data-campo="' + nome + '"]', dove);
    for (var i = 0; i < n.length; i++) n[i].textContent = valore == null ? '' : valore;
  }
  function righeNatura(dove, n) {
    tutti('[data-campo="natura"]', dove).forEach(function (r, i) { r.textContent = n.natura[i] || ''; r.hidden = !n.natura[i]; });
  }

  /*
    La dedica. La sceglie la natura della risposta alla terza domanda, anche
    quando vince un altro monile; la forma con il nome solo se c'e' un nome.
    Il nome entra con sost e poi con textContent: resta testo, sempre.
  */
  function dedica(chiave, n) {
    var d3 = stato.answers[N - 1] || chiave;
    var per = stato.dono ? stato.per : '';
    var modello = (per ? testi.dedica_nome : testi.dedica_te) || {};
    if (!modello[d3]) return null;
    return { v: 1, handle: chiave, dono: !!stato.dono, per: per, dedica: sost(modello[d3], { nome: per }), firma: sost(testi.firma, { monile: n.nome, data: oggi() }) };
  }
  function oggi() {
    var l = dati.lingua === 'en' ? 'en-GB' : dati.lingua;
    try { return new Date().toLocaleDateString(l, { day: 'numeric', month: 'long', year: 'numeric' }); } catch (e) { return new Date().toLocaleDateString(); }
  }

  function mostraEsito(chiave, opz) {
    opz = opz || {};
    var n = nature[chiave];
    if (!n) return;
    var corpo = n.corpo || {};
    corrente = chiave;
    esito.setAttribute('data-natura', chiave);
    var proprio = modo === 'proprio', gia = modo === 'gia';
    /* Chi torna indietro dalla scheda (gia) ritrova la dedica che ha lasciato nella sessione, se e' per questo monile. */
    var d = proprio ? dedica(chiave, n) : gia ? leggi('sessionStorage', DEDICA) : null;
    if (d && (d.v !== 1 || d.handle !== chiave)) d = null;
    var biglietto = el('[data-rito-biglietto]', esito);
    if (biglietto) biglietto.hidden = !d;
    campo('dedica', d && d.dedica, esito);
    campo('firma', d && d.firma, esito);
    if (proprio && d) scrivi('sessionStorage', DEDICA, d);
    campo('nome', n.nome, esito);
    campo('materia', corpo.materia, esito);
    campo('prezzo', corpo.prezzo, esito);
    var foto = el('[data-campo="immagine"]', esito);
    if (foto) {
      if (opz.subito) { foto.setAttribute('fetchpriority', 'high'); foto.setAttribute('loading', 'eager'); }
      foto.hidden = !corpo.immagine;
      if (corpo.immagine) foto.src = corpo.immagine;
      var galleria = el('[data-rito-galleria]', esito);
      if (galleria) sfoglia(galleria, foto, corpo.foto || (corpo.immagine ? [corpo.immagine] : []));
    }
    /* Senza fotografia la parola del monile resta al centro del nero. */
    var nero = el('[data-rito-nero]', esito);
    if (nero) nero.className = corpo.immagine ? 'rito__nero' : 'rito__nero rito__nero--solo';
    var vedi = el('[data-rito-cta="vedi"]', esito);
    if (vedi) { vedi.href = corpo.url || '#'; vedi.hidden = !corpo.url; vedi.textContent = sost(testi.vedi_monile, { nome: n.nome }); }
    var regalo = el('[data-rito-dono]', esito);
    if (regalo) { regalo.textContent = sost(testi.dono_riga, { nome: n.nome }); regalo.hidden = !(d && d.dono && corpo.url); }
    /* Gli altri quattro: resta nascosto solo quello che ha vinto. */
    tutti('[data-rito-altro]', esito).forEach(function (a) { a.hidden = a.getAttribute('data-rito-altro') === chiave; });
    var rifaiVia = el('[data-rito-rifai]', esito);
    if (rifaiVia) rifaiVia.hidden = modo === 'condiviso';
    var prestato = el('[data-rito-prestato]', esito);
    if (prestato) prestato.hidden = modo !== 'condiviso';
    schermo('esito');
    if (!opz.daStoria) storia('esito');
    fuoco('esito');
    annuncia(sost(testi.annuncio_esito, { nome: n.nome }));
  }

  /* La galleria dell'esito (7 ottobre 2026): frecce e dito sfogliano le fotografie del monile. */
  function sfoglia(galleria, foto, lista) {
    var prima = el('[data-rito-sfoglia="-1"]', galleria);
    var dopo = el('[data-rito-sfoglia="1"]', galleria);
    var conta = el('[data-rito-conta]', galleria);
    var piu = lista.length > 1;
    galleria._lista = lista;
    galleria._posto = 0;
    if (prima) prima.hidden = !piu;
    if (dopo) dopo.hidden = !piu;
    if (conta) { conta.hidden = !piu; conta.textContent = piu ? '1 / ' + lista.length : ''; }
    if (galleria._pronta) return;
    galleria._pronta = true;
    function vai(passo) {
      var l = galleria._lista;
      if (!l || l.length < 2) return;
      galleria._posto = (galleria._posto + passo + l.length) % l.length;
      foto.src = l[galleria._posto];
      if (conta) conta.textContent = (galleria._posto + 1) + ' / ' + l.length;
      var seguente = new Image();
      seguente.src = l[(galleria._posto + 1) % l.length];
    }
    galleria.addEventListener('click', function (evento) {
      var bottone = evento.target.closest && evento.target.closest('[data-rito-sfoglia]');
      if (bottone) vai(Number(bottone.getAttribute('data-rito-sfoglia')));
    });
    var inizio = null;
    galleria.addEventListener('touchstart', function (evento) { inizio = evento.touches[0].clientX; }, { passive: true });
    galleria.addEventListener('touchend', function (evento) {
      if (inizio === null) return;
      var scarto = evento.changedTouches[0].clientX - inizio;
      inizio = null;
      if (Math.abs(scarto) > 40) vai(scarto < 0 ? 1 : -1);
    });
  }

  /* Il doppio onesto: due nature intere, il custode sceglie prima di vedere il corpo. */
  function mostraDoppio(v, daStoria) {
    var lati = ['a', 'b'];
    for (var i = 0; i < 2; i++) {
      var n = nature[v.doppia[i]];
      var lato = el('[data-rito-lato="' + lati[i] + '"]', doppio);
      if (!n || !lato) continue;
      campo('nome', n.nome, lato);
      campo('veglia', n.veglia, lato);
      righeNatura(lato, n);
      var b = el('[data-rito-scegli]', lato);
      if (b) {
        b.setAttribute('data-rito-scegli', v.doppia[i]);
        b.setAttribute('data-opzione', v.doppia[i]);
        b.textContent = sost(testi.doppia_scegli, { nome: n.nome });
      }
    }
    schermo('doppio');
    if (!daStoria) storia('doppio');
    var t = fuoco('doppio');
    if (t) annuncia(t.textContent);
  }
  function scegliDoppio(b) {
    if (!ultimoDoppio || inCorso) return;
    var scelta = b.getAttribute('data-rito-scegli');
    var altra = ultimoDoppio.doppia[0] === scelta ? ultimoDoppio.doppia[1] : ultimoDoppio.doppia[0];
    misura('rito_dual_choice', { natura: scelta, alternativa: altra });
    ricorda(scelta, ultimoDoppio.doppia.slice(), 'dual');
    dissolvi(function () { mostraEsito(scelta); });
  }

  /* Chi torna: una riga e quattro vie, la prima "Vedi <nome>". Rifare e' un evento, con una conferma sola. */
  function mostraRitorno(mem) {
    var n = mem && nature[mem.natura];
    if (!n) return false;
    corrente = mem.natura;
    var riga = el('[data-rito-ritorno-riga]', riepilogo);
    if (riga) riga.textContent = sost(testi.ritorno_riga, { nome: n.nome });
    var url = n.corpo && n.corpo.url;
    tutti('[data-rito-corpo]', riepilogo).forEach(function (a) { a.href = url || '#'; a.hidden = !url; a.textContent = sost(testi.vedi_monile, { nome: n.nome }); });
    schermo('ritorno');
    var t = fuoco('ritorno');
    if (t) annuncia(t.textContent);
    return true;
  }
  /* La conferma apre sul No: chi la chiude senza scegliere torna da dove era partito. */
  function apriConferma(da) {
    if (!conferma) { rifai(); return; }
    daConferma = da;
    if (typeof conferma.showModal === 'function') { if (!conferma.open) conferma.showModal(); }
    else conferma.setAttribute('open', '');
    var no = el('[data-rito-conferma-no]', conferma);
    if (no) no.focus();
  }
  function chiudiConferma(rimetti) {
    if (!conferma) return;
    if (!rimetti) daConferma = null;
    if (typeof conferma.close === 'function') { if (conferma.open) conferma.close(); }
    else { conferma.removeAttribute('open'); rimettiFuoco(); }
  }
  function rimettiFuoco() {
    var da = daConferma;
    daConferma = null;
    if (da && da.focus) da.focus();
  }
  if (conferma) conferma.addEventListener('close', rimettiFuoco);
  /* Rifare cancella anche la dedica e svuota il nome: si ricomincia da capo, per chiunque. */
  function rifai() {
    misura('rito_rifai');
    cancella('localStorage', ESITO);
    cancella('sessionStorage', STATO);
    cancella('sessionStorage', DEDICA);
    memEsito = null;
    stato = nuovoStato();
    raggiunto = 0;
    corrente = null;
    modo = 'proprio';
    if (campoNome) campoNome.value = '';
    apriDono(false);
    dissolvi(function () { mostraIntro(true); });
  }
  function mostraIntro(breve) {
    var riga = el('[data-rito-intro-riga]'), rifaiRiga = el('[data-rito-rifai-riga]');
    if (riga) riga.hidden = !!breve;
    if (rifaiRiga) rifaiRiga.hidden = !breve;
    schermo('intro');
    if (breve) { fuoco('intro'); if (rifaiRiga) annuncia(rifaiRiga.textContent); }
  }
  /* Per me comincia subito; per un'altra persona apre il campo del nome, che resta facoltativo. */
  function sceltaPerChi(b) {
    var altri = b.getAttribute('data-rito-per') === 'altri';
    if (!altri || !campoDono) { comincia(altri, ''); return; }
    apriDono(campoDono.hidden);
  }
  function apriDono(apri) {
    if (!campoDono) return;
    campoDono.hidden = !apri;
    tutti('[data-rito-per="altri"]').forEach(function (b) { b.setAttribute('aria-expanded', apri ? 'true' : 'false'); });
    if (apri && campoNome) campoNome.focus();
  }
  /* Dalla schermata di ritorno, Per un'altra persona: l'ingresso con il campo del nome aperto. L'esito di prima resta finche' il nuovo non arriva. */
  function perUnAltra() {
    dissolvi(function () { mostraIntro(false); apriDono(true); });
  }
  function comincia(dono, per) {
    stato = nuovoStato();
    stato.dono = !!dono;
    stato.per = dono ? String(per || '').replace(/^\s+|\s+$/g, '').slice(0, 20) : '';
    raggiunto = 0;
    corrente = null;
    modo = 'proprio';
    cancella('sessionStorage', DEDICA);
    costruisci();
    misura('rito_start', { dono: stato.dono });
    dissolvi(function () { mostraDomanda(1); });
  }

  /* Il nome prestato (?d=): resta leggibile chi arriva da un collegamento di prima; il Rito nuovo non ne crea piu'. */
  function daCondiviso() {
    modo = 'proprio';
    sostituisciStoria('intro', dati.url && dati.url.pagina);
    dissolvi(function () { mostraIntro(false); });
  }

  radice.addEventListener('click', function (e) {
    var t = e.target, b;
    if (!t || !t.closest) return;
    /* Il doppio prima delle opzioni: i suoi bottoni portano tutti e due gli
       agganci, perche' shopify/qa/hooks.json chiede data-opzione anche li'. */
    if ((b = t.closest('[data-rito-scegli]'))) { scegliDoppio(b); return; }
    if ((b = t.closest('[data-opzione]'))) { scegli(b); return; }
    if ((b = t.closest('[data-rito-per]'))) { sceltaPerChi(b); return; }
    if (t.closest('[data-rito-prima]')) { comincia(true, campoNome ? campoNome.value : ''); return; }
    if (t.closest('[data-rito-comincia]')) { e.preventDefault(); comincia(false, ''); return; }
    if (t.closest('[data-rito-salta]')) { saltaDomanda(); return; }
    if (t.closest('[data-rito-indietro]')) { vaiIndietro(); return; }
    if ((b = t.closest('[data-rito-rifai]'))) { e.preventDefault(); apriConferma(b); return; }
    if (t.closest('[data-rito-conferma-si]')) { chiudiConferma(); rifai(); return; }
    if (t.closest('[data-rito-conferma-no]')) { chiudiConferma(true); return; }
    if (t.closest('[data-rito-altra]')) { perUnAltra(); return; }
    if (t.closest('[data-rito-condiviso-cta]')) { daCondiviso(); return; }
    /* Vedi <nome> e gli altri quattro: la misura dice il monile vinto e, per gli altri, quello scelto. */
    if ((b = t.closest('[data-rito-cta]'))) {
      var m = { natura: corrente };
      if (b.getAttribute('data-verso')) m.verso = b.getAttribute('data-verso');
      misura('rito_cta_' + b.getAttribute('data-rito-cta'), m);
      return;
    }
    if (t.closest('[data-rito-uscita]')) {
      var d = {};
      if (corrente) d.natura = corrente;
      if (radice.hasAttribute('data-rito-in-corso')) d.q = stato.step;
      misura('rito_esci_onesto', d);
    }
  });

  /* Invio nel campo del nome vale come La prima domanda. */
  if (campoNome) campoNome.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.isComposing) { e.preventDefault(); comincia(true, campoNome.value); }
  });

  /* Tastiera: le frecce spostano il fuoco fra le opzioni, Invio e Spazio confermano, Tab esce dal gruppo. */
  lista.addEventListener('keydown', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-opzione]') : null;
    if (!b) return;
    var fs = b.closest('[data-passo]');
    if (!fs) return;
    var opz = tutti('[data-opzione]', fs), i = opz.indexOf(b), k = e.key;
    if (k === 'ArrowDown' || k === 'ArrowRight') { e.preventDefault(); sposta(opz, (i + 1) % opz.length); }
    else if (k === 'ArrowUp' || k === 'ArrowLeft') { e.preventDefault(); sposta(opz, (i - 1 + opz.length) % opz.length); }
    else if (k === 'Enter' || k === ' ' || k === 'Spacebar') { e.preventDefault(); scegli(b); }
  });
  function sposta(opz, i) { for (var j = 0; j < opz.length; j++) opz[j].tabIndex = j === i ? 0 : -1; opz[i].focus(); }

  /* Indietro mentre il Daymon parla: tace senza congedo, e la sua fine non porta piu' al monile. */
  window.addEventListener('popstate', function (e) {
    var s = e.state && e.state.rito;
    if (s === 'voce') s = N;
    if (parla) { parla.ferma(); parla = null; }
    if (typeof s === 'number') {
      if (!passi.length || s < 1 || s > N) return;
      if (s < stato.step) misura('rito_back', { q: stato.step });
      dissolvi(function () { mostraDomanda(s, true); }, true);
    } else if (s === 'esito' && corrente) {
      dissolvi(function () { mostraEsito(corrente, { daStoria: true }); }, true);
    } else if (s === 'doppio' && ultimoDoppio) {
      dissolvi(function () { mostraDoppio(ultimoDoppio, true); }, true);
    } else if (s === 'ritorno' && memEsito) {
      cancella('sessionStorage', STATO); stato = nuovoStato(); raggiunto = 0;
      dissolvi(function () { mostraRitorno(memEsito); }, true);
    } else {
      cancella('sessionStorage', STATO); stato = nuovoStato(); raggiunto = 0;
      dissolvi(function () { mostraIntro(false); }, true);
    }
  });

  /* L'avvio: i parametri, la memoria, poi lo stato giusto. */
  var parametri = {};
  try {
    var coppie = window.location.search.replace(/^\?/, '').split('&');
    for (var c = 0; c < coppie.length; c++) {
      var kv = coppie[c].split('=');
      if (kv[0]) parametri[decodeURIComponent(kv[0])] = decodeURIComponent((kv[1] || '').replace(/\+/g, ' '));
    }
  } catch (e) {}

  cancella('localStorage', VECCHIA);
  memEsito = leggi('localStorage', ESITO);
  if (memEsito && (memEsito.v !== 2 || !nature[memEsito.natura])) memEsito = null;
  var memStato = leggi('sessionStorage', STATO);
  stato = nuovoStato();
  if (memStato && memStato.v === 3 && memStato.answers) {
    for (var i = 0; i < N; i++) stato.answers[i] = memStato.answers[i] == null ? null : memStato.answers[i];
    stato.step = Number(memStato.step) || 0;
    stato.seed = Number(memStato.seed) || stato.seed;
    stato.dono = !!memStato.dono;
    stato.per = stato.dono && typeof memStato.per === 'string' ? memStato.per.slice(0, 20) : '';
    raggiunto = Math.max(Number(memStato.raggiunto) || 0, stato.step);
  }
  radice.setAttribute('data-rito', 'pronto');
  /* Con il JavaScript la via verso l'indice lascia il posto alle due scelte. */
  if (perChi) {
    perChi.hidden = false;
    tutti('[data-rito-comincia]').forEach(function (a) { a.hidden = true; });
  }

  /* Indietro (o ricarica) dalla scheda: la voce di cronologia dice esito, e la pagina nera torna con la dedica della sessione. */
  var giaStoria = null;
  try { giaStoria = window.history.state; } catch (e) {}
  var inizio = 'intro';
  if (parametri.d != null) {
    if (nature[parametri.d]) { modo = 'condiviso'; mostraEsito(parametri.d, { daStoria: true, subito: true }); inizio = 'esito'; }
    else mostraIntro(false);
  } else if (giaStoria && giaStoria.rito === 'esito' && memEsito) {
    modo = 'gia';
    mostraEsito(memEsito.natura, { daStoria: true, subito: true });
    inizio = 'esito';
  } else if (parametri.rifai != null && mostraRitorno(memEsito)) {
    inizio = 'ritorno';
  } else if (stato.step > 0 && stato.step <= N) {
    costruisci();
    mostraDomanda(stato.step, true);
    inizio = stato.step;
  } else if (mostraRitorno(memEsito)) {
    inizio = 'ritorno';
  } else {
    mostraIntro(false);
  }
  sostituisciStoria(inizio);
  avviato = true;
})();
